<template>
  <v-container fluid class="header" :class="{ rtl: lang == 'ar' }">
    <div class="header-background"></div>
    <v-layout wrap style="position: relative">
      <transition mode="out-in" name="fade">
        <v-flex class="left-container" md6 xs12 v-if="!submitted" key="slide-1">
          <h1 class="title-1">{{ $t("contact us") }}</h1>
          <h2 class="title-2">{{ $t("we are around") }}</h2>
          <v-form
            style="display: flex; flex-direction: column"
            v-model="validForm"
            ref="form"
            lazy-validation
          >
            <v-text-field
              :rules="[rules.required, rules.letters]"
              :label="$t('full name')"
              box
              v-model="fullName"
              required
              style="width: 100%"
            ></v-text-field>
            <v-text-field
              :rules="[rules.required, rules.email]"
              box
              :label="$t('email')"
              v-model="email"
              required
              style="width: 100%"
            ></v-text-field>
            <v-select
              solo
              :rules="[rules.required]"
              :items="categories"
              item-text="label"
              item-value="value"
              :label="$t('category')"
              v-model="question"
              required
              class="mb-4"
              style="width: 100%"
            ></v-select>
            <v-text-field
              :rules="[rules.required]"
              multi-line
              name=""
              id=""
              cols="30"
              rows="10"
              class="contact-textarea"
              :placeholder="$t('further description')"
              v-model="message"
            ></v-text-field>
            <transition name="fade" mode="out-in">
              <button
                v-if="accessToken !== null"
                @click="submit($event)"
                class="submit"
                :disabled="!validForm"
              >
                Send Message
              </button>

              <div
                v-else
                class="g-recaptcha"
                data-sitekey="6LcIMVAUAAAAAJGqShkeY7Yu68BQ9cvRVyY2zHTX"
                data-callback="verify"
                style="margin: 20px auto"
              ></div>
            </transition>
          </v-form>
        </v-flex>
        <v-flex class="left-container" md6 xs12 v-else key="slide-2">
          <img
            src="../../../static/contact-us/group-3.svg"
            alt=""
            class="image"
            :class="{ 'image-rtl': lang === 'ar' }"
          />
          <h1 class="title-1" style="color: black">
            {{ $t("weWillGetBack") }}
          </h1></v-flex
        >
      </transition>
      <v-flex
        md6
        xs12
        style="position: relative"
        v-reveal="{
          duration: 2000,
          delay: 1000,
          opacity: 0,
          easing: 'ease-out'
        }"
      >
        <img
          src="../../../static/contact-us/group-4.svg"
          class="header-pic"
          :class="{ rtl: lang == 'ar' }"
          alt=""
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import HTTP from "../../http-common";

export default {
  name: "ContactUsHeader",
  inject: ["isShowLoader"],
  data() {
    return {
      validForm: false,
      submitted: false,
      fullName: "",
      email: "",
      question: "",
      message: "",
      accessToken: null,
      categories: [],
      rules: {
        required: value => !!value || this.$t("required"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("invalidEmail");
        },
        letters: value => {
          const pattern = /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z\s]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z-_]*$/;
          return pattern.test(value) || this.$t("invalidName");
        }
      }
    };
  },
  methods: {
    submit(event) {
      event.preventDefault();
      if (this.$refs.form.validate()) {
        const data = {
          fullName: this.fullName,
          email: this.email,
          category: this.question,
          message: this.message
        };
        this.isShowLoader.val = true;
        HTTP.post("/contact-us", data, {
          headers: { "X-Access-Token": this.accessToken }
        }).then(() => {
          this.isShowLoader.val = false;
          this.submitted = true;
        });
      }
    }
  },
  computed: {
    lang() {
      return localStorage.lang || this.$route.path.substring(1, 3);
    },
    submitButtonDisabled() {
      return (
        this.fullName === "" ||
        !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.email
        ) ||
        this.question === "" ||
        this.message.length < 3 ||
        this.message.length > 5000
      );
    }
  },
  created() {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    document.body.appendChild(script);
    window.verify = response => {
      this.accessToken = response;
    };
    HTTP.get("/options/contact-us-categories")
      .then(response => {
        this.categories = response.data.data.sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        });
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error.response);
      });
  }
};
</script>

<style lang="scss" scoped>
.header {
  padding-top: 150px;
  height: 1000px;
  padding-bottom: 480px;
  &.rtl {
    direction: rtl;
  }
  @media screen and (max-width: 450px) {
    padding-top: 80px;
  }
}
.header-pic {
  position: relative;
  object-fit: contain;
  top: 120px;
  right: -10%;
  width: 78%;
  &.rtl {
    right: 10%;
    top: 170px;
    @media screen and (max-width: 450px) {
      right: 0;
      top: 0;
    }
  }
  @media screen and (max-width: 450px) {
    right: 0;
    top: 0;
  }
}
.header-background {
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  right: 0;
  background-image: linear-gradient(318deg, #00caf1, #00a0e2 88%, #009ae0);
  clip-path: polygon(0 0, 100% 0, 100% 70%, 0% 95%);
  z-index: 0;
  @media screen and (max-width: 450px) {
    height: 1350px;
    clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 85%);
  }
}
.left-container {
  padding-top: 120px;
  padding-left: 5%;
  padding-right: 3%;
  text-align: center;
}
.title-1 {
  font-family: Roboto;
  font-size: 64px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.4px;
  color: #ffffff;
  @media screen and (max-width: 450px) {
    font-size: 30px;
    padding-bottom: 10px;
  }
}
.title-2 {
  font-family: Roboto;
  font-size: 35px;
  font-weight: 300;
  letter-spacing: 0.8px;
  color: #ffffff;
  margin-bottom: 45px;
  @media screen and (max-width: 450px) {
    font-size: 25px;
    /*text-align: center;*/
  }
}
.form-container {
  width: 80%;
  @media screen and (max-width: 450px) {
    width: 100%;
  }
}
.contact-input {
  height: 53px;
  border-radius: 6px;
  background-color: #ffffff;
  border: solid 1px #0ba1db;
  outline: none;
  margin-bottom: 25px;
  padding: 20px;
}
.contact-textarea {
  height: 200px;
  border-radius: 6px;
  background-color: #ffffff;
  border: solid 1px #0ba1db;
  resize: none;
  padding: 20px;
}
.submit {
  margin-top: 20px;
  padding: 20px 110px;
  border-radius: 8px;
  background-color: #1d4d5c;
  box-shadow: 0 4px 0 0 #068bc6;
  font-family: Roboto;
  font-size: 23px;
  color: #f2f2f2;
  transition: background-color 0.5s;
  &[disabled="disabled"] {
    background-color: gray;
    box-shadow: none;
    &:hover {
      transform: none;
      box-shadow: none;
    }
  }
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 20px 0 rgba(0, 0, 0, 0.19);
  }
  &:focus {
    background-color: #22a68d;
    transform: translateY(-3px);
    box-shadow: 0 14px 20px 0 rgba(0, 0, 0, 0.19);
  }
  &:active {
    transform: translateY(-1px);
    box-shadow: 0 7px 20px 0 rgba(0, 0, 0, 0.19);
  }
  @media screen and (max-width: 450px) {
    padding: 20px 3px;
  }
}

.fade-enter-active {
  animation: fade 0.5s;
}
.fade-leave-active {
  animation: fade 0.5s reverse;
}
@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.input-group.input-group--solo {
  border-radius: 6px;
  background-color: #ffffff;
  border: solid 1px currentColor;
  box-shadow: none;
  margin-bottom: 20px;
}
.image {
  &.image-rtl {
  }
}
</style>
